<template>
    <div>
        <table>
            <thead>
                <tr>
                    <th>Score Name</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in variableScoreList" :key="`additional-score-${item.id}`">
                    <td :title="item.body.name">{{ item.body.name }}</td>
                    <td :title="item.body.score">{{ item.body.score }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
  
<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
export default {
    props: {
        variablesList: {
            type: Array,
        },
        activityId: {
            type: String,
        },
        participantId: {
            type: String,
        },
        studyId: {
            type: String,
        },
        surveyId: {
            type: String,
        },
        responseVersionId: {
          type: String,
        },
        responseId: {
          type: String,
        },
        activityRevisionId: {
          type: String
        },
        reportedDataTrackerId: {
            type: String
        }
    },
    data() {
        return {
            variableScoreList: []
        }
    },
    methods: {
        getVariableScoreList(responseVersionId, responseId) {
            this.variableScoreList = [];
            let responseVerId = responseVersionId ? responseVersionId : this.responseVersionId;
            let resId = responseId ? responseId : this.responseId;
            nprogress.start();
            if(this.variablesList && this.variablesList.length > 0){
                this.variablesList.map(item => {
                let pathParams = {
                    studyId : this.studyId,
                    participantId : this.participantId,
                    activityId : item.activityId,
                    variableId : item.id,
                    responseId : resId,
                    responseVersionId : responseVerId,
                    activityRevisionId: item.activityRevisionId,
                    surveyId: this.surveyId
                };
                let queryParams = {
                    surveyResponseTrackerId : this.reportedDataTrackerId
                };
                this.$api.evaluateVariable(pathParams, queryParams)
                    .then(
                        response => {
                            response.id = item.id;
                            this.variableScoreList.push(response);
                            nprogress.done();
                        },
                        error => {
                            nprogress.done();
                            let errorBody = error.body;
                            if(errorBody.message == "Cannot divide by 0"){
                                this.variableScoreList.push({body:{name:item.name, score: "Cannot divide by 0"}});
                            }
                            else{
                                this.$toastr.error(
                                error.body && error.body.message
                                    ? error.body.message
                                    : "Error while evaluating variable."
                                );
                            }
                        }
                    );
                });
            }
        },
    },
    mounted() {
      this.getVariableScoreList();
      this.$root.$on('updateScoreValueTab', (responseVersionId, responseId) => {
        this.getVariableScoreList(responseVersionId, responseId);
      });
    },
    
}
</script>

<style scoped lang="scss">
table {
    width: 100%;

    thead {
        tr {
            background: #f9f9fb;
            padding-left: 30px;
            width: 100%;
            display: flex;

            th {
                width: 300px;
                font-size: 14px;
                font-family: Roboto-Bold;
                color: #4a4a4a;
                padding: 15px 30px 15px 0px;

                &:first-child {
                    border-right: 4px solid #fff;
                }

                &:last-child {
                    padding-left: 16px;
                }
            }
        }
    }

    tbody {
        tr {
            display: flex;
            width: 95%;
            border-bottom: 1px solid #d3dfe4;
            margin-left: 30px;

            td {
                width: 300px;
                font-size: 12px;
                font-family: Roboto-Bold;
                color: #4a4a4a;
                padding: 15px 0px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                &:last-child {
                    padding-left: 16px;
                    font-family: Roboto-Regular;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
  